import React from 'react';
import {
  useState,
} from 'react';
import {
  Card,
  TextStyle,
} from '@shopify/polaris';
import TagSelectionComponent from '../../components/TagListComponent';


function TagsPane(props) {

  const [showAllTags, setShowAllTags] = useState(false);
  const tags = showAllTags ? props.allTags : props.tags;
  const handleToggleTagsShown = function () {
    setShowAllTags(!showAllTags);
  }

  return (<Card sectioned
    title="Tags"
    actions={[{ content: showAllTags ? 'Show filtered tags' : "Show all tags", onAction: handleToggleTagsShown }]}>
    <div>
      <p>Showing <TextStyle variation="strong">{tags.length}</TextStyle> unique tags.</p>
      <br></br>
      <TagSelectionComponent tags={tags} onTagClick={props.onTagClick} />
    </div>
  </Card>
  );

}

export default TagsPane;